"use client";

import { RefObject, useEffect } from "react";
import { scheduleDebouncedRefresh } from "@/utils/refresh-debounce";

/**
 * Observes size changes on the given element and triggers a debounced
 * ScrollTrigger.refresh() whenever the layout settles.
 *
 * Use on containers that host heavy assets (3D canvases, videos, images)
 * so triggers recompute against the final measured size once the asset hydrates.
 */
export const useResizeRefresh = (
  ref: RefObject<HTMLElement | null>,
  enabled: boolean = true
): void => {
  useEffect(() => {
    if (!enabled || !ref.current) return undefined;

    const observer = new ResizeObserver(() => {
      scheduleDebouncedRefresh();
    });

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, enabled]);
};
